import React from "react";
import { ABOUT } from "../data/mock";
import Reveal from "../components/Reveal";
import { PageHero, NumberedRow, SectionHead, CTABand } from "../components/SharedUI";

const About = () => {
  const d = ABOUT;
  return (
    <div>
      <PageHero eyebrow={d.eyebrow} lines={d.titleLines} intro={d.intro} />

      {/* Founder card + story */}
      <section className="bg-[var(--cream)] py-24 md:py-32">
        <div className="max-w-[1280px] mx-auto px-6 md:px-8 grid lg:grid-cols-[0.75fr_1.25fr] gap-14 lg:gap-20">
          {/* founder card */}
          <div className="lg:sticky lg:top-32 self-start">
            <Reveal>
              <div className="bg-white rounded-sm p-8 shadow-[0_30px_60px_-30px_rgba(20,22,28,0.25)] border border-black/5">
                <div className="w-full aspect-square rounded-sm bg-[#16233f] grain flex items-center justify-center mb-6 overflow-hidden">
                  <span className="font-serif text-white text-6xl font-bold">PT</span>
                </div>
                <h3 className="font-serif text-2xl font-semibold text-[#14161c]">{d.founderName}</h3>
                <div className="eyebrow mt-1 mb-4">{d.founderRole}</div>
                <p className="text-[#55585f] text-sm leading-relaxed">{d.founderBlurb}</p>
              </div>
            </Reveal>
          </div>

          {/* story */}
          <div>
            {d.story.map((it, i) => (
              <NumberedRow key={it.num} {...it} delay={i * 80} bordered={i !== 0} />
            ))}
            <Reveal delay={120}>
              <blockquote className="mt-12 border-l-2 border-[var(--gold)] pl-8 py-2">
                <p className="font-serif text-2xl md:text-[30px] italic leading-[1.35] text-[#14161c]">
                  {d.pullQuote.text}
                </p>
                <footer className="eyebrow mt-6">{d.pullQuote.author}</footer>
              </blockquote>
            </Reveal>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="grain bg-[#16233f] text-white py-24 md:py-32">
        <div className="max-w-[1280px] mx-auto px-6 md:px-8">
          <Reveal>
            <div className="eyebrow mb-4">{d.values.eyebrow}</div>
          </Reveal>
          <Reveal delay={80}>
            <h2 className="font-serif text-[38px] md:text-[56px] font-semibold mb-16">{d.values.title}</h2>
          </Reveal>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
            {d.values.items.map((it, i) => (
              <Reveal key={it.num} delay={i * 90}>
                <div className="border-t border-white/15 pt-6">
                  <div className="font-serif text-4xl text-[var(--gold)]/70 mb-4">{it.num}</div>
                  <h3 className="font-serif text-2xl font-semibold mb-3">{it.title}</h3>
                  <p className="text-white/60 text-sm leading-relaxed">{it.body}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CTABand title="Work with Preeti" button={d.cta} />
    </div>
  );
};

export default About;
